export interface IRequestsNestedState {
  loading: boolean;
  loaded: boolean;
  status: string;
  data: any;
}

export const defaultRequestState: IRequestsNestedState = {
  loading: false,
  loaded: false,
  status: null,
  data: null,
};
